import API from '@/api'

export default {
  namespaced: true,

  state: () => ({
    groups: [],
    teachers: [],
    cabinets: []
  }),

  mutations: {
    updateGroups(state, groups) {
      state.groups = groups
    },

    updateTeachers(state, teachers) {
      state.teachers = teachers
    },

    updateCabinets(state, cabinets) {
      state.cabinets = cabinets
    }
  },

  actions: {
    async fetchGroups({ commit }, publicationId) {
      commit('updateGroups', await API.getGroups(publicationId))
    },

    async fetchTeachers({ commit }, publicationId) {
      commit('updateTeachers', await API.getTeachers(publicationId))
    },

    async fetchCabinets({ commit }, publicationId) {
      commit('updateCabinets', await API.getCabinets(publicationId))
    },
  }
}
